import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import ControlButton from './ControlButton';
import FileUploadDialogue from './FileUploadDialogue';
import Typography from '@material-ui/core/Typography';
import SearchBox from '../../../components/SearchBox';
import * as track from '../../../lib/track';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '0 1rem 0.5rem 0',
    width: '100%',
    marginBottom: '1rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      padding: '0.5rem 0',
      flexWrap: 'wrap',
    },
  },
  deleteButton: {
    padding: '0.4rem 0.7rem',
    marginRight: '1rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginRight: 0,
      marginBottom: '1rem',
    },
  },
  uploadButton: {
    padding: '0.4rem 0.7rem',
    border: '1px solid transparent',
    color: theme.palette.common.white,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  search: {
    width: '40rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  buttons: {
    width: 'inherit',
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-around',
      padding: '2rem 0rem 1rem 0rem',
      flexWrap: 'wrap',
    },
  },
}));

const DocumentsHeader = ({loading, checkedCount, showDeleteGroup, searchQuery, onSearchChange, subtitle=''}) => {
  const classes = useStyles();
  const [uploadDialogueOpen, setUploadDialogueOpen] = useState(false);

  const openUploader = () => {
    track.sendEvent('upload documents button', 'click', {});
    setUploadDialogueOpen(true);
  };

  return (
    <Box className={classes.root}>
      <div className={classes.search}>
        <Typography variant="body2" gutterBottom>{loading ? '' : subtitle}</Typography>
        <SearchBox
          placeholder="Search by name, category or source..."
          value={searchQuery}
          onSearchChange={onSearchChange}
        />
      </div>
      <div className={classes.buttons}>
        <ControlButton
          label="Delete checked items"
          icon="delete"
          variant="outlined"
          color="primary"
          className={classes.deleteButton}
          onClick={showDeleteGroup}
          disabled={checkedCount === 0}
        />
        <ControlButton
          label="Upload documents"
          icon="upload"
          variant="contained"
          color="secondary"
          className={classes.uploadButton}
          onClick={openUploader}
        />
      </div>
      <FileUploadDialogue
        open={uploadDialogueOpen}
        onClose={()=>setUploadDialogueOpen(false)}
      />
    </Box>
  );
};

DocumentsHeader.propTypes = {
  loading: PropTypes.bool.isRequired,
  checkedCount: PropTypes.number.isRequired,
  showDeleteGroup: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  subtitle: PropTypes.string,
};

export default DocumentsHeader;
